import type React from 'react'
import { ChartBar } from '@phosphor-icons/react'
import { cn } from '@/lib/utils'

/**
 * The analytics empty-chart placeholder — one neutral icon chip over a 13px
 * line of copy, sitting in the space the chart would occupy.
 *
 * Was declared five times (Overview / Deliverability / Campaigns / Replies /
 * Contacts tabs), byte-identical apart from the phosphor glyph. The glyph is
 * now a prop so each tab keeps its own subject icon.
 */
export function EmptyChart({
  message,
  icon = <ChartBar className="h-5 w-5" weight="regular" />,
  className,
}: {
  message: string
  icon?: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-16 text-muted-foreground dark:text-[#8a8f98]',
        className,
      )}
    >
      <div className="h-12 w-12 rounded-md bg-muted/70 dark:bg-white/[0.04] dark:border dark:border-white/[0.05] flex items-center justify-center mb-3">
        {icon}
      </div>
      <p style={{ fontSize: '13px', letterSpacing: '-0.13px' }}>{message}</p>
    </div>
  )
}

export default EmptyChart
